const doc = [({"da":({"js":({"nemoa_select":({"type_something_to_search":"Indtast noget for at søge..."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;